export const PARTNER_CONFIG = {
  apiUrl: "https://whitelabel.staging-colossusbets.com/api",
  localesUrl: "//d18icbgk5z9c1l.cloudfront.net/i18n",
  imagesUrl: "//d20xk4sxen1bs2.cloudfront.net",
  websocketsUrl: 'ws-eu.pusher.com',
  websocketsKey: '73c617c8039669312058',
  websocketCluster: 'eu',
  enableSyndicates: true,
  enableFreeplay: true,
  widgetImages: [{
    default: '/assets/images/widget/colossus/placeholder.jpg'
  }],

  haveGroupedTickets: true,

  /* imported from colossus & wallet */
  micrositeType: ['SPORTS', 'RACING'],
  allowNewGroupCategoryCreation: false,


  'templateServiceUrl': 'https://templates.colossusbets.com/?uuid=[UUID_CODE]&merchant=colossus',
  'enableVideoStreaming': true,
  'ravenUrl': 'https://0c14f07ea4c545beb5697a5cccb860a9@o113114.ingest.sentry.io/5389973',
  'ravenRelease': 'colossus@1.6.9',
  'ravenEnvironment': 'web',
  'videoStreamingSport': ['GREYHOUNDS'],
  'videoStreamUrl': 'https://v.sis.tv/StreamingService/api/v2/stream?',
  'merchant_code': 'CB',
  'streamUrl': 'https://wl.staging-colossusbets.com/streams',
  'scopes': ['locales', 'competitors', 'syndicates', 'wallet', 'sharing'],
  'allowLogin': false,
  'allowRegister': false,
  'allowBalance': true,
  'crossSellStakeTier': 1,
  'enableSyndicatesLeaderboard': true,
  'freePlayStandaloneLogo': '/assets/images/standalone/colossus/racing-freeplay-logo.png',
  'faqUrl': 'https://www.colossusbets.com/help/?utm_source=CB.com&utm_medium=CB.com&utm_campaign=Header%20Link',
  'allowLinkCopy': true,
  'showPoolBestDividend': true,
  'haveSeoData': true,
  'enableShare': true,
  'shareListEnabled': true,
  'shareRafEnabled': true,
  'shareRafTextVersions': 1,
  'defaultLanguage': 'en',
  'supportedLanguages': [
    'en', 'zh-CN', 'zh-TW', 'ja', 'ko-KR', 'id-ID', 'th-TH', 'vi-VN',
    'fr', 'pt', 'es', 'cs', 'ru', 'tr', 'hy', 'de', 'fi', 'hu', 'nb',
    'pl', 'sv', 'ge', 'pt-BR', 'en-NL', 'nl', 'fr-BE', 'el', 'uk-UA',
    'es-CO', 'es-PE', 'et'
  ],
  'poolTypesOrder': {
    'FOOTBALL.MATCH': 10,
    'FOOTBALL.HDA': 20,
    'FOOTBALL.CORRECT_SCORE': 30,
    'FOOTBALL.OVER_UNDER': 40,
    'FOOTBALL.BTTS': 50,
    'FOOTBALL.ASIAN_HANDICAP': 60,
    'NFL.POINT_MARGIN': 70,
    'NBA.POINT_MARGIN': 80,
    'TENNIS.CORRECT_SCORE_3': 90,
    'TENNIS.CORRECT_SCORE_5': 100,
    'TENNIS.H2H': 110,
    'WRC.RACE_ORDER': 120,
    'WRC.RACE_WIN': 130,
    'HORSE_RACING.RACE_WIN': 140,
    'HORSE_RACING.RACE_PLACE': 150,
    'HORSE_RACING.RACE_ORDER': 160
  },
  'socialNetworks': { 'twitter': true, 'facebook': true, 'whatsapp': true },
  'shareSyndicateDynamicText': true,
  'numberOfSharingTextVersions': 10,
  'enableStats': false,
  'haveManagerRebates': true,
  'haveVoidToSolo': true,
  'haveTwitterWidgets': true,
  'widgetBanners': {
    SPORTS: [{ 'default': { image: '/assets/images/widget/colossus/placeholder.jpg', path: null, external: false } }],
    RACING: [{ 'default': { image: '/assets/images/widget/colossus/racing.jpg', path: null, external: false } }],
    HORSE_RACING: [{ 'default': { image: '/assets/images/widget/colossus/racing.jpg', path: null, external: false } }]
  },
  // 'haveHomepage': true,
  'homepageHelpGlobal': '?utm_source=Colossus&utm_medium=homepage&utm_campaign=goto',
  'homepageLoggedOutLink': '/category/promotions/new-player-bonus/?utm_source=Colossus&utm_medium=homepage&utm_campaign=npb',
  'homepageLoggedInLink': '/what-is-the-freeplay-loyalty-scheme/?utm_source=Colossus&utm_medium=homepage&utm_campaign=loyalty',
  'homepageBlogLink': 'https://www.colossusbets.com/blog/?utm_source=Colossushome&utm_medium=header',
  'blackListedPageviewPaths': ['landing'],
  'trackVirtualPageviews': true,
  'persistentLandingPage': true,
  'alwaysNewUser': false,
  'enableInternalTracking': true,
  'stickyBetslip': true,
  'bannerExpirationTimeout': 7,
  'shareWithTwitterHandler': true,
  'trackingUrl': 'https://tracking.colossusbets.com/',
  dhFeaturedDefaultImage: 'feature_pool_generic.png',
  dhFeaturedStaticImage: 'feature_pool_right_image_fixed.jpg',
  freeplayReadMore: 'https://www.colossusbets.com/blog?utm_source=Colossus&utm_medium=home&utm_campaign=widget',
  freeplayLoayaltyLearnMore: 'https://www.colossusbets.com/help/what-is-the-freeplay-loyalty-scheme/?utm_source=Colossus&utm_medium=home&utm_campaign=loyalty',
  bdgReadMore: 'https://www.colossusbets.com/help/what-is-best-dividend-guaranteed/?utm_source=Colossus&utm_medium=home&utm_campaign=bdg',
  npbReadMore: 'https://www.colossusbets.com/help/what-is-the-new-player-bonus/?utm_source=Colossus&utm_medium=home&utm_campaign=npb',
  hideFreeplayTab: true,
  rootUrl: '/'
};
